import { createContext, useContext } from "react";

// Shared between YjsStoryProvider and downstream loaders (LoadContentProvider).
// In single-seat accounts YjsStoryProvider never mounts, so the default
// `{ enabled: false, synced: true }` makes "wait for Yjs sync" a no-op
// for those flows.
export type YjsSyncStatus = {
  enabled: boolean;
  synced: boolean;
  // Resolves once the room reports it has flushed local edits to the server
  // (and in-flight peer ops have had a beat to land), or when `timeoutMs`
  // elapses. Returns true if convergence was reached, false on timeout. Used by
  // publish so it never snapshots a doc that's still mid-sync (Monday
  // #12337353624). No-op (resolves true) outside a collaborative room.
  waitForConverged: (timeoutMs?: number) => Promise<boolean>;
};

const defaultStatus: YjsSyncStatus = {
  enabled: false,
  synced: true,
  waitForConverged: async () => true,
};

export const YjsSyncContext = createContext<YjsSyncStatus>(defaultStatus);

export const useYjsSyncStatus = () => useContext(YjsSyncContext);
